import { Notifier } from "@airbrake/browser";

if (window.env.JEKYLL_ENV === "production") {
  try {
    window.airbrake = new Notifier({
      projectId: window.env.AIRBRAKE_PROJECT_ID,
      projectKey: window.env.AIRBRAKE_PROJECT_KEY,
      host: "https://panel.sutty.nl",
    });

    console.originalError = console.error;
    console.error = (...e) => {
      window.airbrake.notify(e.join(" "));
      return console.originalError(...e);
    };
  } catch (e) {
    console.error(e);
  }
}

import * as Turbo from "@hotwired/turbo";
Turbo.start();

import { Application } from "@hotwired/stimulus";
window.Stimulus = Application.start();
window.abortController = undefined;

import DarkModeController from "./controllers/dark_mode_controller";
import PagefindController from "./controllers/pagefind_controller";

Stimulus.debug = window.env.JEKYLL_ENV !== "production";
Stimulus.register("dark-mode", DarkModeController);
Stimulus.register("pagefind", PagefindController);

document.addEventListener("turbo:load", (event) => {
  window.abortController = new AbortController();
});

document.addEventListener("turbo:visit", (event) => {
  window.abortController.abort();
});
